import {Select} from "chakra-react-select";
import {useTranslation} from "react-i18next";
import {useState, useEffect} from "react";
import {getAxiosInstance} from "../../../utils/axiosInstance";

type Category = {
    value: string,
    label: string,
    colorScheme: string,
    isMain: boolean,
}

interface addCategory {
    selectedCategory: Category[],
    setSelectedCategory: (value: Category[]) => void;
}

const AddCategory = (props: addCategory) => {
    const {
        selectedCategory,
        setSelectedCategory
    } = props;

    const {t} = useTranslation("translations");
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [formattedCategoriesList, setFormattedCategoryList] = useState<Category[]>([]);
    const [mainCategory, setMainCategory] = useState<Category | null>(null);


    const [name, setName] = useState<string>("");

    const fetchCategory = async (name: string) => {
        setIsLoading(true);
        try {
            const res = await getAxiosInstance().get(`/Categories/ByName/${name}${mainCategory ? '/' + mainCategory.value : ''}`);
            setFormattedCategoryList(res.data.map((x: any) => ({
                value: x.id,
                label: x.name,
                colorScheme: "yellow",
                isMain: x.parentId === null
            })))
        } catch (e) {
            console.error(e);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchCategory(name.length > 0 ? name : "null").then(() => {});
    }, [name, mainCategory]);

    useEffect(() => {
        if (mainCategory == null && selectedCategory.length > 0) {
            const mainCategory = selectedCategory.findIndex(x => x.isMain);
            if (mainCategory !== -1) {
                setMainCategory(selectedCategory[mainCategory]);
            }
        }
    }, [selectedCategory]);

    return (
        <>
            <Select
                name={t("SELECT_Category")}
                options={formattedCategoriesList}
                value={selectedCategory}
                tagVariant="solid"
                placeholder={t("SELECT_CATEGORY_PLACEHOLDER")}
                onInputChange={(e) => setName(e)}
                inputValue={name}
                onChange={(e) => {
                    if (e) {
                        setSelectedCategory(e as any)
                    }
                }}
                isLoading={isLoading}
                isMulti
            />
        </>

    )
}

export default AddCategory;